import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-id": "confirm-dialog-title"
}
const _hoisted_2 = {
  "data-id": "confirm-dialog-description",
  class: "mt-2px"
}
const _hoisted_3 = { class: "dialog-card-action-buttons px-5 pt-2 pb-10" }

import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  confirmButtonText: {
    type: String,
    default: undefined,
  },
  cancelButtonText: {
    type: String,
    default: undefined,
  },
  confirmButtonColor: {
    type: String,
    default: 'primary',
  },
  hideCancelButton: Boolean,
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

// For further documentation regarding custom programmatic dialogs:
// https://quasar.dev/quasar-plugins/dialog





const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_c_btn = _resolveComponent("c-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "c-dialog",
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        "data-id": "confirm-dialog",
        class: "dialog-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "px-5 pt-6 pb-4" }, {
            default: _withCtx(() => [
              (__props.title)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(__props.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_c_btn, {
              "data-id": "confirm-dialog-ok-button",
              label: __props.confirmButtonText || _ctx.$t('inri.common.confirm'),
              color: __props.confirmButtonColor,
              onClick: _unref(onDialogOK)
            }, null, 8, ["label", "color", "onClick"]),
            (!__props.hideCancelButton)
              ? (_openBlock(), _createBlock(_component_c_btn, {
                  key: 0,
                  "data-id": "confirm-dialog-cancel-button",
                  label: __props.cancelButtonText || _ctx.$t('inri.common.cancel'),
                  color: "surface",
                  onClick: _unref(onDialogCancel)
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})